module.exports = __webpack_public_path__ + "img/h-page4-22.47b940a5.png";